import {
  PatientEducationModulePath,
  PatientEducationVideoId,
} from '@usacsmideo/types';

export type PatientEducationModule = {
  videoId: PatientEducationVideoId;
  title: string;
  storagePath: PatientEducationModulePath;
};

export const PATIENT_EDUCATION_MODULES: ReadonlyArray<PatientEducationModule> = [
  {
    videoId: 'patientEducation_module01',
    title: 'What Are Advance Directives?',
    storagePath: PatientEducationModulePath.Module01,
  },
  {
    videoId: 'patientEducation_module02',
    title: 'Real World Scenarios',
    storagePath: PatientEducationModulePath.Module02,
  },
  {
    videoId: 'patientEducation_module03',
    title: 'Why do You Need an Advance Directive?',
    storagePath: PatientEducationModulePath.Module03,
  },
  {
    videoId: 'patientEducation_module04',
    title: 'What is the Solution?',
    storagePath: PatientEducationModulePath.Module04,
  },
  {
    videoId: 'patientEducation_module05',
    title: 'Next Steps',
    storagePath: PatientEducationModulePath.Module05,
  },
] as const;
